<div class="row no-outline" id="bill-acct-manage-component" tabindex="0">
  <div class="column twelve">
    <!-- The data has come back and we have billAccounts -->
    @if (rows.length && !dataLoading) {
      <div>
        <ngx-datatable
          #billAccountsTable
          #scheduledPaymentsTable
          [ngClass]="cssClasses"
          [cssClasses]="{
            pagerLeftArrow: 'icon-chevron-left',
            pagerRightArrow: 'icon-chevron-right',
            pagerPrevious: 'icon-arrow-left-double',
            pagerNext: 'icon-arrow-right-double'
          }"
          class="none md-block"
          [rows]="rows"
          [columns]="columns"
          [columnMode]="'force'"
          [headerHeight]="headerHeight"
          [rowHeight]="rowHeight"
          [footerHeight]="footerHeight"
          [limit]="pageLimit"
          [scrollbarH]="true"
          (page)="onPageChanged()"
        >
          <ngx-datatable-row-detail [rowHeight]="'auto'">
            <ng-template #rowDetailTpl let-row="row" ngx-datatable-row-detail-template>
              @if (showContent === 'managedElsewhere' || showContent === 'aftContent') {
                <div class="pad-20">
                  <div class="row">
                    <div class="column twelve">
                      @if (showContent === 'managedElsewhere') {
                        <span
                          dsContent
                          [contentPath]="'billing.managedElsewhere'"
                          data-cy="managedElsewhere"
                        ></span>
                      }
                      @if (showContent === 'aftContent') {
                        <span
                          dsContent
                          [contentPath]="'billing.enrolledInAft'"
                          data-cy="enrolledInAft"
                        ></span>
                      }
                      <span *dsPartnerAFI data-cy="partnerContactNumber">{{ contactNumber }}</span>
                      <span
                        *dsPartnerConnect
                        dsPartnerContent
                        [brandContent]="'selectPrettyCusCareNumber'"
                      ></span>
                      <span>.</span>
                    </div>
                  </div>
                </div>
              }
            </ng-template>
          </ngx-datatable-row-detail>
        </ngx-datatable>
        <ds-table
          class="block md-none"
          [rows]="rows"
          [columns]="columns"
          [headerHeight]="headerHeight"
        >
        </ds-table>
      </div>
    }

    <!-- The data has come back and we DO NOT have billAccounts -->
    @if (!rows.length && !dataLoading) {
      <p class="error-600-text error-600-border pad-20">
        <span
          *dsPartnerAFI
          dsContent
          [contentPath]="'billing.noBillingAccountsAvailable'"
          data-cy="noBillingAccountsAvailable"
        ></span>
        <span
          *dsPartnerConnect
          dsContent
          [contentPath]="'billing.noBillingAccountsAvailablePartners'"
          data-cy="noBillingAccountsAvailablePartners"
        ></span>
      </p>
    }

    <!-- The data has not come back yet -->
    @if (dataLoading) {
      <ds-localized-spinner
        class="block pad-bottom-20"
        [dataLoading]="dataLoading"
        [loadingMessage]="'Looking for billing accounts...'"
      >
      </ds-localized-spinner>
    }

    @if (numberOfcheckedBillAccounts > 6) {
      <div class="pad-top-20 pad-bottom-20 error-600-text">
        <span class="icon-alert"></span>
        <span
          class="margin-left-5"
          dsContent
          [contentPath]="'billing.maxBillAccountsSelectedWarningSectionPage'"
        ></span>
      </div>
    }
  </div>
</div>

<ng-template #headerCellTpl let-column="column">
  <div class="header-cell table-header-cell-wrapper">
    <span
      [ngClass]="{
        'none lg-block': column?.name && column?.shortName,
        block: column?.name && !column?.shortName
      }"
      >{{ column?.name }}</span
    >
    @if (!!column?.shortName) {
      <span class="block lg-none">{{ column?.shortName }}</span>
    }
  </div>
</ng-template>

<ng-template #checkCellTpl let-row="row" let-value="value">
  <ds-checkbox-toggle
    data-cy="billingOverviewPayCheckbox"
    labelText="PAY"
    [inputValue]="value"
    [inputRow]="row"
    [inputDisabled]="
      row.disable || (roleService.isAuthorized('makemyacctpayment_walkthrough') | async) === false
    "
    (change)="rowCheckChanged(row.accountObj, $event.target.checked)"
  ></ds-checkbox-toggle>
</ng-template>

<ng-template #acctCellTpl let-row="row" let-value="value" let-column="column">
  <div class="acct-cell ds-table-body-cell-header-wrapper overflow-hidden">
    @if (value) {
      <span class="none md-block cell">
        <a
          tabindex="0"
          class="cell-title"
          (click)="routeToDetailView(row.billAccountNumber)"
          data-cy="Accountnumber"
        >
          @if (!value.isNickname || row.accountObj.registeredElsewhere) {
            <span>{{ value.name | prettyBillingAcctNum }}</span>
          }
          @if (value.isNickname && !row.accountObj.registeredElsewhere) {
            <span [attr.title]="value.name + '\nAccount Number: ' + row.billAccountNumber"
              >{{ value.name }}
            </span>
          }
        </a>
        @if (isAdminApp && value.isNickname) {
          <p>
            {{ row.billAccountNumber | prettyBillingAcctNum }}
          </p>
        }
      </span>
    }

    <!-- this is mobile view for single bill account -->
    @if (value) {
      <div class="ds-table-body-cell-header">
        <button
          ds-button
          class="margin-right-10 pay-button"
          [disabled]="
            row.disable ||
            (roleService.isAuthorized('makemyacctpayment_walkthrough') | async) === false
          "
          [ngClass]="{
            '-outline-white':
              row.disable ||
              (roleService.isAuthorized('makemyacctpayment_walkthrough') | async) === false
          }"
          (click)="paySingleAccount(row.accountObj)"
          aria-label="Pay"
        >
          Pay
        </button>
        <a
          tabindex="0"
          class="no-decoration overflow-hidden"
          (click)="routeToDetailView(row.billAccountNumber)"
        >
          @if (!value.isNickname || row.accountObj.registeredElsewhere) {
            <h2 class="primary-800-text margin-0">
              {{ value.name | prettyBillingAcctNum }}
            </h2>
          }
          @if (value.isNickname && !row.accountObj.registeredElsewhere) {
            <h2
              class="primary-800-text margin-0"
              [attr.title]="value.name + '\nAccount Number: ' + row.billAccountNumber"
            >
              {{ value.name }}
            </h2>
          }
        </a>
      </div>
    }
  </div>
</ng-template>

<ng-template #dueDateCellTpl let-row="row" let-value="value" let-column="column">
  @if (value) {
    <span class="due-date-cell">
      <p class="due-date-cell-amount">{{ value.dueAmount }}</p>
      @if (value.dueAmount !== '$0.00' && value.dueDate !== '01/01/0001') {
        <p class="due-date-cell-date">Pay by {{ value.dueDate | dateFormat }}</p>
      }
    </span>
  }
</ng-template>

<ng-template
  #statusCellTpl
  let-row="row"
  let-value="value"
  let-expanded="expanded"
  let-column="column"
>
  <div class="status-cell">
    @if (value) {
      <span class="due-date-cell">
        <p class="margin-0 due-date-cell-status" [ngClass]="row.status.statusClass">
          {{ row.status.statusText }}
        </p>
        @if (!!row.status.statusDate && row.status.statusDate !== '0001-01-01T00:00:00.0-0600') {
          <p class="due-date-cell-date">
            {{ row.status.statusDate | dateFormat }}
          </p>
        }
        @if (!!row.status.statusSubText) {
          <p class="due-date-cell-date">
            {{ row.status.statusSubText }}
          </p>
        }
        @if (!!row.accountObj.enabledAFT) {
          <p class="none md-block due-date-cell-date">
            @if (!expanded) {
              <a href="javascript:void(0);" class="no-decoration" (click)="getAftMsg(row)"
                >View Details</a
              >
            }
            @if (expanded) {
              <a href="javascript:void(0);" class="no-decoration" (click)="onCloseRow(row)"
                >Hide Details</a
              >
            }
          </p>
        }
      </span>
    }
    @if (!value) {
      <span class="due-date-cell">
        <p class="margin-0 due-date-cell-status">Unavailable</p>
        <p class="none md-block due-date-cell-date">
          @if (!expanded) {
            <a href="javascript:void(0);" class="no-decoration" (click)="getUnavailableMessage(row)"
              >View Details</a
            >
          }
          @if (expanded) {
            <a href="javascript:void(0);" class="no-decoration" (click)="onCloseRow(row)"
              >Hide Details</a
            >
          }
        </p>
      </span>
    }
  </div>
</ng-template>

<ng-template #statementCellTpl let-row="row" let-value="value" let-column="column">
  <div class="statement-cell">
    @if (!value) {
      <span class="caption neutral-600-text">Unavailable</span>
    }
    @if (value) {
      <a
        (click)="
          openStatement(
            documentApi +
              'documents/' +
              value.documentId +
              '?levelOfDetails=document&classification=Billing'
          )
        "
        class="no-decoration"
        target="_blank"
        title="Current Bill PDF"
        ><i class="statement icon-pdf"></i
      ></a>
    }
  </div>
</ng-template>
